export const initialState = {
  actionProcessing: false,
  rate: 0,
  agentCommission: 0,
  isPaymentLoading: false,
  paymentLink: null,
  amount: 0,
  depositInitData: {
    id: 0,
    replenishmentAddress: '',
    status: 0,
    fromCurrency: '',
    fromCurrencyAmount: 0,
    toCurrency: '',
    toCurrencyAmount: 0,
    createdAt: new Date(),
    validUntil: new Date(),
    commissionPercent: 0,
  },
  depositInfo: {
    id: 0,
    replenishmentAddress: '',
    status: 0,
    clientExternalId: 0,
    fromCurrency: '',
    fromCurrencyAmount: 0,
    toCurrency: '',
    toCurrencyAmount: 0,
    createdAt: new Date(),
    validUntil: new Date(),
    paidAt: new Date(),
    blockchainTransactionId: 0,
  },
  depositHistory: {
    deposits: [],
    count: 0,
  },
};
